import React, { Component } from 'react';
import { Button, Input, message, Switch } from 'antd';
import DocumentTitle from 'react-document-title';
import API from '@/api/api';
import Loading from '@/page/components/loading/loading';
import './index.less';
import MapModel from '@/page/components/map/map';
import UEditor from "@/page/components/ueditor/ueditor";

var uploader = require('../../../thirdTool/alioss/upload.js');
const { TextArea } = Input;

message.config({
    top: 200,
    duration: 2,
    maxCount: 3,
});

class musicAdd extends Component {

    constructor(props) {
        super(props)
    }

    state = {
        visible: false,
        functionList: [], // 功能列表
        phone: '',
        logo: '',
        summary: '',
        circleName: '',
        longitude: '',
        latitude: '',
        location: '',
        background: '',
        circleName: '',
        functionTypeList: [],
        circleId: '',
        isLoading: true,
    }


    async componentDidMount() {
        await this.musicFunctionList();
        console.log('circleId', this.props.location);
        let circleId = this.props.location.state && this.props.location.state.circleId;
        if (circleId) {
            this.setState({ circleId }, () => {
                this.musicCircleDetail();
            })
        } else {
            this.setState({ isLoading: false })
        }
        let buttonList = [
            {
                buttonID: 'chooseLogo',
                picType: 'logo',
                extensions: 'jpg,png,bmp,jpeg',
            },
            {
                buttonID: 'chooseBackground',
                picType: 'background',
                extensions: 'jpg,png,bmp,jpeg',
            }
        ]
        buttonList.map((item, index) => {
            this.initUpload(item)
        })
    }

    async getPictureInfo(url) { // 获取图片信息
        let result = await API.syncPic({ url: url });
        if (!result) return;
        if (result) {
            let picObj = {
                picture: url,
                width: result.ImageWidth.value,
                height: result.ImageHeight.value
            }
            return picObj;
        }
        else {
            message.error(result.msg);
        }
    };

    async musicCircleDetail() { // 获取活动详情
        const { circleId } = this.state;
        let result = await API.musicCircleDetail({ circleId });
        if (!result) return;
        if (result.status == 1) {
            let ttLeActivity = result.data;
            let functionList = this.state.functionList;
            let functionTypeList = JSON.parse(ttLeActivity.functionTypeList);
            functionTypeList.map((item) => {
                functionList.map((listItem) => {
                    if (listItem.functionType == item) {
                        listItem.checked = true;
                    }
                })
            })
            this.setState({
                location: JSON.parse(ttLeActivity.location),
                summary: ttLeActivity.summary,
                phone: ttLeActivity.userPhone,
                circleName: ttLeActivity.circleName,
                functionList,
            }, () => {
                this.setState({ isLoading: false }, () => {
                    //图片类型处理
                    let buttonList = [
                        { buttonID: 'chooseBackground', picObj: ttLeActivity.background ? JSON.parse(ttLeActivity.background) : '' },
                        { buttonID: 'chooseLogo', picObj: ttLeActivity.logo ? JSON.parse(ttLeActivity.logo) : '' },
                    ]
                    buttonList.map((item) => {
                        if (item.picObj) {
                            let picObj = item.picObj;
                            switch (item.buttonID) {
                                case 'chooseBackground':
                                    this.setState({ background: picObj })
                                    break;
                                case 'chooseLogo':
                                    this.setState({ logo: picObj })
                                    break;
                            }
                            if (document.getElementById(item.buttonID)) {
                                if (picObj.picture)
                                    document.getElementById(item.buttonID).style.backgroundImage = 'url(' + picObj.picture + ')';
                                else if (picObj.pictureUrl)
                                    document.getElementById(item.buttonID).style.backgroundImage = 'url(' + picObj.pictureUrl + ')';
                                else {
                                    document.getElementById(item.buttonID).style.backgroundImage = 'url(' + picObj + ')';
                                }
                            }
                        }
                    })
                })
            })
        }
        else {
            message.error(result.msg);
        }
    };

    async musicFunctionList() {
        const { circleId } = this.state;
        let result = await API.musicFunctionList({ circleId: circleId });
        if (!result) return;
        if (result.status == 1) {
            this.setState({
                functionList: result.data.functionList
            })
        }
    };

    async musicEditCircle(params) {
        let result = await API.musicEditCircle(params);
        if (!result) return;
        if (result.status == 1) {
            message.success(result.msg);
            window.history.back()
        } else {
            message.error(result.msg);
        }
    };


    initUpload(item) { //初始化视频上传
        let self = this;
        setTimeout(() => {
            if (document.getElementById(item.buttonID)) {
                console.log('item.buttonID', item.buttonID)
                uploader({
                    serverUrl: window.location.origin + '/promotion/oss/policy',
                    upload_button: item.buttonID,
                    multi: false,
                    extensions: item.extensions,
                    added: function () {
                    },
                    success: function (file_url, file) {
                        self.getPictureInfo(file_url).then(obj => {
                            if (item.picType == 'logo') {
                                self.setState({
                                    logo: obj
                                })
                            }
                            if (item.picType == 'background') {
                                self.setState({
                                    background: obj
                                })
                            }
                            document.getElementById(item.buttonID).style.backgroundImage = 'url(' + obj.picture + ')';
                        });
                    },
                    error: function (msg) {
                        message.error(msg)
                    }
                })
            }
        }, 100)
    }


    getQueryString(name) {//解析url
        const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        const urlObj = window.location;
        var r = urlObj.href.indexOf('#') > -1 ? urlObj.hash.split("?")[1].match(reg) : urlObj.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    }

    saveActivity() {

        const {
            functionList,
            phone,
            logo,
            summary,
            location,
            background,
            circleName,
            circleId
        } = this.state;

        if (!phone) {
            message.error('请输入管理员手机号')
            return
        }

        if (!circleName) {
            message.error('请输入公众圈名称')
            return
        }

        if (!logo) {
            message.error('请上传公众圈头像')
            return
        }

        if (!summary) {
            message.error('请输入公众圈介绍')
            return
        }

        if (!background) {
            message.error('请上传公众圈封面')
            return
        }

        if (!location) {
            message.error('请选择公众圈位置')
            return
        }

        let functionTypeList = functionList.map((item) => {
            if (item.checked) {
                return item.functionType
            }
        }).filter(Boolean);

        let data = {
            functionTypeList: JSON.stringify(functionTypeList),
            phone,
            logo: JSON.stringify(logo),
            summary,
            longitude: location.longitude,
            latitude: location.latitude,
            location,
            circleName,
            background: JSON.stringify(background),
            circleId
        }
        console.log('data', data)
        this.musicEditCircle(data)
    }

    inputItemChange(type, e) {
        let value = e.target.value;
        if (type == 'phone') {
            this.setState({ phone: value })
        }
        if (type == 'circleName') {
            this.setState({ circleName: value })
        }

    }

    onChange = ({ target: { value } }) => {
        console.log('value', value)
        this.setState({ summary: value });
    };

    switchChange(index, checked, event) {
        console.log('value', checked, event, index);
        let functionList = this.state.functionList;
        functionList[index].checked = checked;
        this.setState({ functionList })
    }

    openModel() {
        this.setState({ visible: true })
    }
    handleCancel() {
        this.setState({ visible: false })
    }
    mapChange(location) {
        console.log('location', location)
        this.setState({ location, visible: false })
    }

    handleUEditorChange = (content) => { //编辑器
        this.setState({ summary: content.trim() });
    }

    render() {
        const {
            location,
            visible,
            summary,
            functionList,
            phone,
            logo,
            circleName,
            background,
            circleId,
            isLoading,
        } = this.state;
        console.log('functionList', functionList)
        if (isLoading) return <Loading />;

        return (
            <DocumentTitle title="音乐公众圈">
                <div className="musicAdd">
                    <div className="inputItem">
                        <span className="inputTitle">管理员</span>
                        <Input className="inputBlock" value={phone} placeholder="手机号" onChange={this.inputItemChange.bind(this, 'phone')}></Input>
                    </div>
                    <div className="inputItem">
                        <span className="inputTitle">公众圈名称</span>
                        <Input className="inputBlock" value={circleName} placeholder="" onChange={this.inputItemChange.bind(this, 'circleName')}></Input>
                    </div>
                    <div className="inputItem">
                        <span className="inputTitle">公众圈头像</span>
                        <div id="chooseLogo" className="chooseLogo"></div>
                    </div>
                    <div className="inputItem">
                        <span className="inputTitle">公众圈介绍</span>
                        {
                            ((circleId && summary) || !circleId) && <UEditor id='couponUseExplain' content={summary} onChange={this.handleUEditorChange.bind(this)} />
                        }
                    </div>
                    <div className="inputItem">
                        <span className="inputTitle">公众圈封面</span>
                        <div id="chooseBackground" className="chooseBackground"></div>
                    </div>
                    <div className="inputItem">
                        <span className="inputTitle">公众圈位置</span>
                        <Button onClick={this.openModel.bind(this)} type="link" block>{location ? location.name : '请选择位置'}</Button>
                        <MapModel onChange={this.mapChange.bind(this)} visible={visible} handleCancel={this.handleCancel.bind(this)} location={location} />
                    </div>

                    <div className="inputItem">
                        <span className="inputTitle">公众圈应用</span>
                        <div className='functionList'>
                            {
                                functionList && functionList.length > 0 &&
                                functionList.map((item, index) => {
                                    return (
                                        <div key={item.functionType} className='functionItem'>
                                            <span className='functionName'>{item.functionName}</span>
                                            <Switch checkedChildren="开" unCheckedChildren="关" checked={item.checked ? true : false} onChange={this.switchChange.bind(this, index)} />
                                        </div>
                                    )
                                })
                            }

                        </div>
                    </div>

                    <Button onClick={this.saveActivity.bind(this)}>{circleId ? '保存' : '创建'}</Button>
                </div>
            </DocumentTitle>
        )
    }
}
export default musicAdd;
